import type { FaireProductEntity } from "../../entity_types/product";

export const p_vadjn4bt5r: FaireProductEntity = {
  token: "p_vadjn4bt5r",
  type: "product",
  name: "autumn assorted notecard set",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/8ca10b6bfe366bafc4f0299f00671551908064a6cd76121c6421cbd2ffc8cc49.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/44d70957783fe0d1322a09be62e81bdeb11912913de18d6873d7b5ab273fe0c8.jpeg",
    "https://cdn.faire.com/fastly/0cebb6c73acf2aefc431033b473e1125e45f890c435ac39248199d60d8704f5f.jpeg",
    "https://cdn.faire.com/fastly/eacd005d3f6077b93a5562b962ef8733ec1797b7fee19553c6a332ccff07780b.jpeg",
    "https://cdn.faire.com/fastly/fd28533af9eae1fbfe3b86a0413f1cdcbd923b60dd4610300be6487a2b41178b.jpeg",
    "https://cdn.faire.com/fastly/2d63180cc010faf20ae2de9378610fec4c2b8c79bec912215471f3117a4904a6.jpeg",
    "https://cdn.faire.com/fastly/1c9d540d248cdc7c3e31117177947aa42ef16a3a296ac9d428ca2fb7e51749e5.jpeg",
    "https://cdn.faire.com/fastly/be81dbf9c73a9d23594b955c9d75fae0d1e43b7e44bb8d7213a9d32b7a382689.jpeg",
  ],
  priceDollars: 8,
  description:
    'The assorted set of autumn notecards are blank on the inside with charming watercolor illustrations of a maple leaf, acorn, white pumpkin and green pumpkin on the front. They bring a touch of fall delight to your thank you notes, housewarming gifts, get-well wishes, and more.\n\n𝐃𝐞𝐭𝐚𝐢𝐥𝐬:\n\n• set of eight folded cards + envelopes, two of each illustration\n• blank inside\n• 5.5" x 4.25"\n• Printed on 120lb superfine paper\n• Original watercolor artwork by Emily Lex',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:45.931Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
